/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnStationComponentType } from './en-station-component-type';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface StationComponentDto
 */
export interface StationComponentDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof StationComponentDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof StationComponentDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof StationComponentDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof StationComponentDto
     */
    deleted: string | null;

    /**
     * @type {string}
     * @memberof StationComponentDto
     */
    psn: string;

    /**
     * @type {EnStationComponentType}
     * @memberof StationComponentDto
     */
    type: EnStationComponentType;

    /**
     * @type {string}
     * @memberof StationComponentDto
     */
    manufacturer: string;

    /**
     * @type {string}
     * @memberof StationComponentDto
     */
    supplier: string;

    /**
     * @type {string}
     * @memberof StationComponentDto
     */
    purchased: string;

    /**
     * @type {number}
     * @memberof StationComponentDto
     */
    warranty?: number;

    /**
     * @type {string}
     * @memberof StationComponentDto
     */
    note?: string;

    /**
     * @type {JoinEntityDto}
     * @memberof StationComponentDto
     */
    station: JoinEntityDto;
}
